<template>
  <md-card class="gray-1 bg old-globals" v-if="!verified">
    <md-progress-bar v-if="loading" md-mode="query"></md-progress-bar>
    <md-card-header>
      <div class="md-layout md-alignment-center-center header-content">
        <img class="logo" alt="VRpatients Logo" src="../../../assets/images/VRP_Logo.png" />
      </div>
    </md-card-header>
    <md-card-content>
      <div class="form-error" v-if="error">{{ error.message }}</div>A confirmation email has been sent. Please follow the link in that email to finish your account creation.
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <div>
        <div v-if="verificationEmailSent">Verification email sent</div>
      </div>
      <div class="action-buttons">
        <md-button class="md-raised" @click="logout">Logout</md-button>
        <md-button class="md-raised md-primary" @click="resendVerificationEmail">Resend Verification Email</md-button>
      </div>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "EmailVerificationForm",
  props: ["verified", "loading", "error", "verificationEmailSent"],
  data: () => ({
    state: {}
  }),
  methods: {
    resendVerificationEmail() {
      this.$emit("resendVerificationEmail");
    },
    logout() {
      this.$emit('logout');
    },
  }
};
</script>

<style>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
</style>
